
import React from "react";
import { Button } from "@/components/ui/button";
import { QrCode, Download } from "lucide-react";

type QRCodeDisplayProps = {
  businessName: string;
  qrCodeUrl: string;
  handleDownloadStyledQR: () => Promise<void>;
};

export const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ 
  businessName, 
  qrCodeUrl, 
  handleDownloadStyledQR 
}) => {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-6 mb-8 hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-center gap-3 mb-4">
        <QrCode className="w-6 h-6 text-gebeya-pink" />
        <h2 className="text-lg font-semibold">QR Code</h2>
      </div>
      
      <div className="space-y-4">
        <div className="bg-gradient-to-r from-gebeya-pink to-gebeya-orange p-4 rounded-lg flex flex-col items-center space-y-2">
          <h3 className="text-white text-xl font-bold">SCAN ME</h3>
          <div className="bg-white p-3 rounded-lg">
            {qrCodeUrl ? (
              <img 
                src={qrCodeUrl}
                alt="Styled QR Code"
                className="w-32 h-32"
              />
            ) : (
              <div className="w-32 h-32 flex items-center justify-center bg-gray-100">
                <QrCode className="w-8 h-8 text-gray-400" />
              </div>
            )}
          </div>
          <p className="text-white font-semibold text-lg">{businessName}</p>
        </div>
        <Button 
          onClick={handleDownloadStyledQR} 
          variant="outline"
          className="w-full flex items-center justify-center gap-2"
          disabled={!qrCodeUrl}
        >
          <Download className="w-4 h-4" />
          Download QR Code
        </Button>
      </div>
    </div>
  );
};
